import { z } from 'zod';

import { listSearchSchema } from '@/shared/patterns/list-search';

import { chatbotFilters } from './chatbot.filters';

// `validateSearch` das rotas do Chatbot (U07). Leve de propósito: é JS inicial.

/** Sheet aberto na URL (`?sheet=`, U26): filtros no iPhone. */
const sheet = z.string().min(1).max(40).optional().catch(undefined);

/** `/chatbot`: página (a partir de 1), tamanho e os filtros do legado. */
export const chatbotListSearch = listSearchSchema({ ...chatbotFilters.shape, sheet });
export type ChatbotListSearch = z.infer<typeof chatbotListSearch>;

/** Abas do registro na ordem do legado (ChatbotFormContainer.tsx:228-234); a primeira não vai para a URL. */
export const CHATBOT_TABS = ['informacoes', 'atendimento'] as const;
export type ChatbotTab = (typeof CHATBOT_TABS)[number];

/** `/chatbot/$id`: a aba (`?tab=`, U42); `/chatbot/$id/atendimento` do legado redireciona para cá. */
export const chatbotDetailSearch = z.object({
  tab: z.enum(CHATBOT_TABS).optional().catch(undefined),
  sheet,
});
export type ChatbotDetailSearch = z.infer<typeof chatbotDetailSearch>;
